import { render, staticRenderFns } from "./AnnouncementsBanner.vue?vue&type=template&id=161fff6b&scoped=true"
import script from "./AnnouncementsBanner.vue?vue&type=script&lang=ts"
export * from "./AnnouncementsBanner.vue?vue&type=script&lang=ts"
import style0 from "./AnnouncementsBanner.vue?vue&type=style&index=0&id=161fff6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161fff6b",
  null
  
)

export default component.exports